export const clerkAppearance = {
  variables: {
    colorBackground: '#0c1222',
    colorDanger: '#f97373',
    colorInputBackground: '#0f172a',
    colorInputText: '#f8fafc',
    colorPrimary: '#f5b53f',
    colorSuccess: '#34d399',
    colorText: '#f8fafc',
    colorTextSecondary: 'rgba(226, 232, 240, 0.74)',
    borderRadius: '1rem',
    fontFamily: 'Inter, ui-sans-serif, system-ui, sans-serif',
  },
  elements: {
    card: 'clerk-card',
    footerActionLink: 'clerk-footer-link',
    formButtonPrimary: 'clerk-primary-button',
    formFieldInput: 'clerk-input',
    formFieldLabel: 'clerk-label',
    formFieldSuccessText: 'clerk-success-text',
    formResendCodeLink: 'clerk-footer-link',
    headerSubtitle: 'clerk-header-subtitle',
    headerTitle: 'clerk-header-title',
    identityPreviewEditButton: 'clerk-secondary-button',
    identityPreviewText: 'clerk-identity-text',
    navbar: 'clerk-navbar',
    navbarButton: 'clerk-navbar-button',
    otpCodeFieldInput: 'clerk-otp-input',
    pageScrollBox: 'clerk-page-scroll-box',
    profileSectionPrimaryButton: 'clerk-secondary-button',
    profileSectionTitleText: 'clerk-profile-section-title',
    socialButtonsBlockButton: 'clerk-secondary-button',
    socialButtonsBlockButtonText: 'clerk-secondary-button-text',
    userButtonPopoverCard: 'clerk-card',
    userButtonPopoverActionButton: 'clerk-user-button-action',
    userButtonPopoverActionButtonText: 'clerk-user-button-action-text',
  },
} as const;
